import { PaymentFormField } from './paymentMethod.model';

export enum InputTypes {
  Text = 'text',
  Number = 'number',
  Checkbox = 'checkbox',
  Amount = 'amount',
  AccountId = 'accountId',
  Regex = 'regex',
  Integer = 'integer',
  Select = 'select',
  Email = 'email',
  DateTime = 'date_mm_yyyy',
  Cvv = 'cvv',
  CardCvc = 'card_cvc',
  Phone = 'phone',
  DynamicSelect = 'dynamic_select',

  CreditCardNumber = 'creditcard_number',
  CreditCardVisa = 'creditcard_visa',
  CardNumber = 'card_number',
  CreditCardMastercard = 'creditcard_mastercard',

  IdentificationNumber = 'identification_number',
  PayzenPayTmAccountNumber = 'payzen_paytm_account_number',
  PayzenImpsAccountNumber = 'payzen_imps_account_number',
  Hidden = 'hidden',
  /* specific types for Display container */
  Input = 'input',
  Url = 'url',
  Button = 'button',
  QrCode = 'qr_code',
  CopyableText = 'copyable_text',
  ExpirationDate = 'expirationDate',
  FileLink = 'file_link',
  FiatAmount = 'fiatAmount',
}

export enum InputModes {
  Numeric = 'numeric',
  Decimal = 'decimal',
  Text = 'text',
}

export enum ValidatorTypes {
  COMMON = 'common',
  AMOUNT = 'amount',
}

export enum ValidationStatuses {
  SUCCESS = 'success',
  FAILED = 'failed',
  UNDEFINED = 'undefined',
}

export type PayLoadValue = string | boolean | number | null;

export interface FormField extends PaymentFormField {
  validatorType: ValidatorTypes;
}

export interface FormPayloadItem {
  value: PayLoadValue;
  validationStatus: ValidationStatuses;
  interactionCompleted: boolean;
  isUiOnly?: boolean;
  errors: string[];
}

export interface FormPayload {
  [name: string]: FormPayloadItem;
}

export enum FormStatuses {
  INITIATED = 'initiated',
  FAILED = 'failed',
  READY = 'ready',
  LOADING = 'loading',
  SUBMITTED = 'submitted',
  SUCCEEDED = 'succeeded',
}
